module.exports = __webpack_public_path__ + "img/voice-icon5.1725e2c.png";